<script setup>
import { computed, inject, onMounted, ref, watch } from 'vue';
import { useQuasar } from 'quasar';
import { Routes } from '@/router/router.const';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { useI18n } from 'vue-i18n';
import { useCommonPersistentDataProvider } from '@/components/common/services/commonDataService';
import { IKCommonPersistentData } from '@/components/common/services/commonDataService.types';
import { useRouter } from 'vue-router';
import { useOsService } from '@/services/OsService/OsService';

useCommonPersistentDataProvider();
const $q = useQuasar();
const { t } = useI18n();
const router = useRouter();
const platformAuthentication = inject(IKPlatformAuthentication);
const commonPersistentData = inject(IKCommonPersistentData);
const body = t('changePassword.body');
const notificationHandler = ref(null);
const osService = useOsService();
const isInnerPage = computed(() => !!platformAuthentication?.getAccessToken() && router.currentRoute.value.name !== Routes.EnterLicense);
const shouldDisplay = computed(() => osService?.isWindows.value && !commonPersistentData.getDefaultPasswordNotifyClosed.value && platformAuthentication?.accessTokenDecoded.value.shouldChangePassword);

const handleChangePassword = () => {
  router.push(`/${Routes.UserProfileChangePassword}`);
  if (notificationHandler.value) {
    notificationHandler.value();
    commonPersistentData?.setDefaultPasswordNotifyClosed(true);
  }
};

onMounted(() => {
  if (shouldDisplay.value) {
    notificationHandler.value = $q.notify({
      message: `<div class='message'>${body}</div>`,
      type: 'dark',
      classes: 'notify-box notify-box-good notify-box-dark change-password-suggestion',
      badgeStyle: 'opacity: 0;',
      icon: '',
      position: 'bottom-right',
      timeout: 0,
      html: true,
      actions: [
        {
          icon: 'close',
          color: 'white',
          class: 'close',
          handler: () => {
            commonPersistentData?.setDefaultPasswordNotifyClosed(true);
          },
        },
        {
          label: t('changePassword.actionButton'),
          color: 'white',
          handler: () => handleChangePassword(),
        },
      ],
    });
  }
});

watch(
  () => isInnerPage.value,
  newValue => {
    if (!newValue && notificationHandler.value) {
      notificationHandler.value();
    }
  },
  {
    immediate: true,
  },
);
</script>
<style lang="scss">
.q-notifications__list {
  z-index: 6000 !important;
}
.change-password-suggestion {
  margin: 14px 24px !important;
  height: 110px !important;
  div.q-notification__wrapper {
    display: flex;
    flex-direction: column !important;
  }
  .message {
    width: 400px;
    margin-right: 30px;
    font-family: 'Gordita-Regular';
    font-weight: 400;
  }
  .close {
    position: absolute;
    right: 16px;
    top: -58px;
    color: white;
  }
  div.q-notification__actions {
    width: 100%;
    padding: 0 38px 8px 38px;
    display: flex;
    justify-content: flex-start;
    align-items: start;
    button span span {
      border: 1px solid #ffffff3d;

      border-radius: 2px;
      padding: 4px 17px;
      text-wrap: nowrap;
    }
    button.q-btn {
      font-family: 'Gordita-Medium';
      font-weight: 500;
      text-transform: none;
      .block:hover {
        border-radius: 2px !important;
      }
    }
  }
}
</style>
